import request from '@/utils/request'

// 添加收藏（心仪对象）
export function addFavorite(memberId, favoriteMemberId) {
    return request({
        url: '/api/MemberFavorite/Add',
        method: 'post',
        params: { memberId, favoriteMemberId }
    })
}

// 取消收藏
export function removeFavorite(memberId, favoriteMemberId) {
    return request({
        url: '/api/MemberFavorite/Remove',
        method: 'post',
        params: { memberId, favoriteMemberId }
    })
}

// 获取收藏的会员ID列表
export function getFavoriteList(memberId) {
    return request({
        url: `/api/MemberFavorite/GetList/${memberId}`,
        method: 'get'
    })
}

// 批量检查是否收藏
export function checkFavorites(memberId, favoriteMemberIds) {
    return request({
        url: '/api/MemberFavorite/CheckFavorites',
        method: 'post',
        params: { memberId },
        data: favoriteMemberIds
    })
}

// 检查单条是否收藏
export function isFavorite(memberId, favoriteMemberId) {
    return request({
        url: '/api/MemberFavorite/IsFavorite',
        method: 'get',
        params: { memberId, favoriteMemberId }
    })
}

// 获取收藏的会员详情列表（心仪对象）
export function getFavoriteMembers(memberId) {
    return request({
        url: `/api/MemberFavorite/GetFavoriteMembers/${memberId}`,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/memberFavorite.js